import React, { Fragment, useEffect, useState, useRef, useImperativeHandle, forwardRef } from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import Select, { StylesConfig } from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fetchAPI from '../../common/fetchAPI';
import { ShowToast } from '../../common/Toastr';
import moment from 'moment';
import clsx from 'clsx';
import { AttachmentUpload } from '../attachment/AttachmentUpload';
import { addAttachment } from '../attachment/AttachmentSlice';
import GetAttachments from '../attachment/AttachmentItem';
import { useTranslation } from 'react-i18next';
import {
    updateIsLoading, addAccountEmployeeTimeOffRequest,
    updateAccountEmployeeTimeOffRequest, updatePreferences
} from '../timeoffrequest/timeoffrequestSlice';
// import { dropDownSelectionStyles, dateFormatByAccountCulture } from '../../common/timeLiveFunction';
import { determineCommaSeprater, validateCultureNumber, getValueFromResource, formatNumberCustomoriginal, parseLocalizedNumber, formatNumberCustomoriginalapiv2, dropDownSelectionStyles, dateFormatByAccountCulture, FormatInvoiceDecimalNumber } from '../../common/timeLiveFunction';
import CanvasLoader from '../../common/CanvasLoader';
const initialValues = {
    timeOffTypeArray: [],
    projectArray: [],
    accountTimeOffTypeId: '',
    accountTimeOffTypeName: '',
    startDate: new Date(),
    endDate: new Date(),
    accountProjectId: 0,
    description: '',
    dayOff: 0,
    hoursOff: 0,
    request: 0,
    balanceBeforeRequest: 0,
    balanceAfterRequest: 0,
    isConsumptionAvailable: false,
    sessionHoursPerDay: 0,
    tempEditId: '',
    tempAddId: '',
    tempTypeId: '',
    isCanvasLoader: true
}

const TimeOffRequestAddUpdate = forwardRef((props: any, ref: any) => {
    const [timeOffResponse, setTimeOffResponse] = useState<any | ''>(initialValues);
    const [tab, setTab] = useState('Basic');
    const [tempAttachmentId, setTempAttachmentId] = useState(null);
    const attachmentUploadClearRef = useRef<any>(null);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    // const { sessionAccountEmployeeId, maxMenuHeight, hoursPerDay, isShowTimeOffInDays: isShowTimeOffInDays_preference, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, calendarStartDay, enableUploadFeature } = useAppSelector((state) => state.globalState);
    const { decimalPlaces,sessionAccountEmployeeId, maxMenuHeight, hoursPerDay, isShowTimeOffInDays: isShowTimeOffInDays_preference, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, calendarStartDay, enableUploadFeature } = useAppSelector((state) => state.globalState);
    const { accountemployeetimeoffrequestid, isShowTimeOffInDays, isShowProjectForTimeOff, isHideTimeOffHoursInformation, culture } = useAppSelector((state) => state.timeoffrequest);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const dayOffTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
        const hourOffTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
        const [timeOffMode, setTimeOffMode] = useState<'Days' | 'Hours'>('Days');
    useEffect(() => {
         if (dayOffTimeoutRef.current) { clearTimeout(dayOffTimeoutRef.current); dayOffTimeoutRef.current = null; }
        if (hourOffTimeoutRef.current) { clearTimeout(hourOffTimeoutRef.current); hourOffTimeoutRef.current = null; }
        renderTimeOffRequestFields().then((result) => {
        }).catch((error) => {
        });
        setTab('Basic');
        setTimeOffMode('Days');
        clearAttachmentUpload();
    }, [accountemployeetimeoffrequestid]);

    // useEffect(() => {
    //     timeOffResponse.tempEditId != '' && GetTimeOffCalculation(false, false);
    //     timeOffResponse.tempAddId == 'Add' && GetTimeOffCalculation(false, false);
    // }, [timeOffResponse.tempEditId, timeOffResponse.tempAddId]);
    useEffect(() => {
        timeOffResponse.tempEditId != '' && GetTimeOffCalculation(false, false, '', '', '', false);
        timeOffResponse.tempAddId == 'Add' && GetTimeOffCalculation(false, false, '', '', '', true);
    }, [timeOffResponse.tempEditId, timeOffResponse.tempAddId]);

    useEffect(() => {
        timeOffResponse.tempTypeId != '' && GetTimeOffCalculation(false, false);
    }, [timeOffResponse.tempTypeId]);

    useEffect(() => {
        return () => {
            if (dayOffTimeoutRef.current) clearTimeout(dayOffTimeoutRef.current);
            if (hourOffTimeoutRef.current) clearTimeout(hourOffTimeoutRef.current);
        };
    }, []);
    
     useImperativeHandle(ref, () => ({
        refreshData: () => {
            renderTimeOffRequestFields();
        }
    }));

    const renderTimeOffRequestFields = async () => {
        const response = await fetchAPI(`api/V2/TimeOffs/GetAllDataInSingleRequestForMobileApp?AccountEmployeeId=${sessionAccountEmployeeId}&IsTimeOffRequestRequired=false&AccountEmployeeTimeOffRequestId=${accountemployeetimeoffrequestid}`, 'Get', '', true);
        const json = await response.json();
        json["AccountTimeOffType"].map((item: any) => {
            item.value = item.AccountTimeOffTypeId;
            item.label = item.AccountTimeOffType;
            delete item.AccountTimeOffTypeId;
            delete item.AccountTimeOffType;
        });
        json["AccountProject"].unshift({ AccountProjectId: 0, ProjectName: "<None>" });
        json["AccountProject"].map((item: any) => {
            item.value = item.AccountProjectId;
            item.label = item.ProjectName;
            delete item.AccountProjectId;
            delete item.ProjectName;
        });
        let preferencesObject = {
            "isShowTimeOffInDays": json["AccountPreferences"][0].IsShowTimeOffInDays != null ? json["AccountPreferences"][0].IsShowTimeOffInDays : false,
            "isShowProjectForTimeOff": json["AccountPreferences"][0].ShowProjectForTimeOff,
            "isLockSubmittedRecords": json["AccountPreferences"][0].LockSubmittedRecords,
            "isLockApprovedRecords": json["AccountPreferences"][0].LockApprovedRecords,
            "isHideTimeOffHoursInformation": json["AccountPreferences"][0].HideTimeOffHoursInformation,
            "culture": json["AccountPreferences"][0].CultureInfoName == 'auto' ? 'en-US' : json["AccountPreferences"][0].CultureInfoName
        }
        dispatch(updatePreferences(preferencesObject));
        setTimeOffResponse({
            ...timeOffResponse,
            timeOffTypeArray: json["AccountTimeOffType"],
            projectArray: json["AccountProject"],
            accountTimeOffTypeId: accountemployeetimeoffrequestid != '' ? json["AccountEmployeeTimeOffRequest"][0].AccountTimeOffTypeId : json["AccountTimeOffType"][0].value,
            accountTimeOffTypeName: accountemployeetimeoffrequestid != '' ? json["AccountEmployeeTimeOffRequest"].filter((x: any) => x.value == json["AccountTimeOffType"][0].AccountTimeOffTypeId)[0].label : json["AccountTimeOffType"][0].label,
            //startDate: accountemployeetimeoffrequestid != '' ? moment(json["AccountEmployeeTimeOffRequest"][0].StartDate).toDate() : new Date(),
            // //startDate: accountemployeetimeoffrequestid != '' ? dateFormatByCulture(json["AccountEmployeeTimeOffRequest"][0].StartDate, CurrentCultureDateFormat) : new Date(),
            startDate: accountemployeetimeoffrequestid != '' ? dateFormatByAccountCulture(moment.parseZone(json["AccountEmployeeTimeOffRequest"][0].StartDate).format(dateInsertionFormat), cultureInfoName.toString()) : new Date(),
            //endDate: accountemployeetimeoffrequestid != '' ? moment(json["AccountEmployeeTimeOffRequest"][0].EndDate).toDate() : new Date(),
            // //endDate: accountemployeetimeoffrequestid != '' ? dateFormatByCulture(json["AccountEmployeeTimeOffRequest"][0].EndDate, CurrentCultureDateFormat) : new Date(),
            endDate: accountemployeetimeoffrequestid != '' ? dateFormatByAccountCulture(moment.parseZone(json["AccountEmployeeTimeOffRequest"][0].EndDate).format(dateInsertionFormat), cultureInfoName.toString()) : new Date(),
            accountProjectId: accountemployeetimeoffrequestid != '' ? json["AccountEmployeeTimeOffRequest"][0].AccountProjectId == null ? timeOffResponse.accountProjectId : json["AccountEmployeeTimeOffRequest"][0].AccountProjectId : 0,
            description: accountemployeetimeoffrequestid != '' ? json["AccountEmployeeTimeOffRequest"][0].Description : '',
            dayOff: accountemployeetimeoffrequestid != '' ? json["AccountEmployeeTimeOffRequest"][0].DayOff : 0,
            hoursOff: accountemployeetimeoffrequestid != '' ? json["AccountEmployeeTimeOffRequest"][0].HoursOff : 0,
            sessionHoursPerDay: json["AccountWorkingDays"][0].HoursPerDay,
            isConsumptionAvailable: json["AccountWorkingDays"][0].EnableBalanceValidationForTimeOff,
            tempEditId: accountemployeetimeoffrequestid != '' ? accountemployeetimeoffrequestid : '',
            tempAddId: accountemployeetimeoffrequestid != '' ? 'Edit' : 'Add',
            isCanvasLoader: false
        });
    }

    const parseFlexibleDecimal = (value: string) => {
        return Number(value.replace(',', '.')).toFixed(2);
    }

    const formatMaxTwo = (value: any, isComma: boolean = false) => {
        if (value == null || value === "") return "";

        let num = parseFloat(String(value).replace(',', '.'));
        if (isNaN(num)) return value;

        let rounded = num.toFixed(2).replace(/\.?0+$/, "");

        if (isComma) rounded = rounded.replace('.', ',');

        return rounded;
    };


    const GetTimeOffCalculation = async (IsFromHoursOff: boolean, IsFromDaysOff: boolean, date: string = '', dateStatus: string = '',  latestValue: string = '', isDateChanged: boolean = false) => {
        //A work Comment out
        // let isCommaSeparated = false;        
        const { startDate, endDate, dayOff, hoursOff, sessionHoursPerDay, accountTimeOffTypeId } = timeOffResponse;
        const cultureInfo = cultureInfoName === 'auto' ? 'en-US' : cultureInfoName;
       // const dayOffValue = IsFromDaysOff ? (latestValue || dayOff) : dayOff;
       // const hoursOffValue = IsFromHoursOff  ? (latestValue || hoursOff) : hoursOff;




        // const dayOffValue = IsFromDaysOff ? (latestValue && latestValue.trim() !== '' ? latestValue : dayOff) : dayOff;
        // const hoursOffValue = IsFromHoursOff ? (latestValue && latestValue.trim() !== '' ? latestValue : hoursOff) : hoursOff;
        const dayOffValue = IsFromDaysOff ? (latestValue && latestValue.trim() !== '' ? latestValue : '0') : dayOff;
        const hoursOffValue = IsFromHoursOff ? (latestValue && latestValue.trim() !== '' ? latestValue : '0') : hoursOff;
        console.log('dayOffValue', dayOffValue, 'hoursOffValue', hoursOffValue)
        //A work Comment out
        // let strForhoursOff
        // let strFordayOff
        // let parsedhoursOff
        // let parseddayOff
        // isCommaSeparated = determineCommaSeprater(cultureInfoName.toString());
        let newStartDate = dateStatus === "StartDate" ? date : startDate;
        let newEndDate = dateStatus === "EndDate" ? date : endDate;

        if (!moment(newStartDate, dateInsertionFormat, true).isValid()) {
            newStartDate = startDate;
        }

        if (!moment(newEndDate, dateInsertionFormat, true).isValid()) {
            newEndDate = endDate;
        }

        if (moment(newStartDate).isAfter(moment(newEndDate))) {
            if (dateStatus === "StartDate") {
                newEndDate = newStartDate;
            }
            if (dateStatus === "EndDate") {
                newStartDate = newEndDate;
            }
        }

        if (moment(newEndDate).isBefore(moment(newStartDate))) {
            newStartDate = newEndDate;
        }
        // if (cultureInfoName.toString() === 'es-AR') {
        //     strForhoursOff = String(hoursOff).replace('.', ',');
        //     strFordayOff = String(dayOff).replace('.', ',');


        //     parsedhoursOff = strForhoursOff
        //     parseddayOff = strFordayOff

        // }
        // else {
        //     strForhoursOff = String(hoursOff).replace(',', '.');
        //     strFordayOff = String(dayOff).replace(',', '.');
        //     parsedhoursOff = parseFloat(strForhoursOff)
        //     parseddayOff = parseFloat(strFordayOff)
        // }
        //A Work Comment out start
        // if (isCommaCulture) {
        //     strForhoursOff = String(hoursOff).replace('.', ',');
        //     strFordayOff = String(dayOff).replace('.', ',');
        //     parsedhoursOff = strForhoursOff;
        //     parseddayOff = strFordayOff;
        // }
        // else {
        //     strForhoursOff = String(hoursOff).replace(',', '.');
        //     strFordayOff = String(dayOff).replace(',', '.');
        //     parsedhoursOff = parseFloat(strForhoursOff);
        //     parseddayOff = parseFloat(strFordayOff);
        // }
        //A Work Comment out end
        let strForhoursOff
        let strFordayOff
        let parsedhoursOff
        let parseddayOff
        const isCommaSeparator = determineCommaSeprater(cultureInfoName.toString());
        //for 'en-US'            
        if (isCommaSeparator === false) {
            strForhoursOff = String(hoursOffValue).replace(',', '.');
            strFordayOff = String(dayOffValue).replace(',', '.');
            parsedhoursOff = parseFloat(strForhoursOff)
            parseddayOff = parseFloat(strFordayOff)
        }
        //for 'es-AR'
        if (isCommaSeparator) {
            strForhoursOff = String(hoursOffValue).replace(',', '.');
            strFordayOff = String(dayOffValue).replace(',', '.');
            parsedhoursOff = parseFloat(strForhoursOff)
            parseddayOff = parseFloat(strFordayOff)
        }
        //A Work Comment out
        //const response = await fetchAPI(`api/V2/TimeOffs/GetTimeOffCalculation?StartDateTextBox=${moment(newStartDate).format(dateInsertionFormat)}&EndDateTextBox=${moment(newEndDate).format(dateInsertionFormat)}&DaysOffTextBox=${parseddayOff}&HoursOffTextBox=${parsedhoursOff}&IsFromHoursOff=${IsFromHoursOff}&IsFromDaysOff=${IsFromDaysOff}&CultureInfo=${cultureInfo}&SessionHoursPerDay=${sessionHoursPerDay}&TimeOffTypeId=${accountTimeOffTypeId}&TimeOffRequestId=${accountemployeetimeoffrequestid}&ShowTimeOffInDays=${isShowTimeOffInDays}`, 'Get', '', true);
        const response = await fetchAPI(`api/V2/TimeOffs/GetTimeOffCalculation?StartDateTextBox=${moment(newStartDate).format(dateInsertionFormat)}&EndDateTextBox=${moment(newEndDate).format(dateInsertionFormat)}&DaysOffTextBox=${strFordayOff}&HoursOffTextBox=${strForhoursOff}&IsFromHoursOff=${IsFromHoursOff}&IsFromDaysOff=${IsFromDaysOff}&CultureInfo=${cultureInfo}&SessionHoursPerDay=${sessionHoursPerDay}&TimeOffTypeId=${accountTimeOffTypeId}&TimeOffRequestId=${accountemployeetimeoffrequestid}&ShowTimeOffInDays=${isShowTimeOffInDays}&IsDateChanged=${isDateChanged}`, 'Get', '', true);
        const json = await response.json();   
        
        let isCommaSeparated = false;
                //for 'es-AR'
        if (isCommaSeparator) {
            isCommaSeparated = true
        }
        //for 'en-US'      
        if (isCommaSeparator === false) {
            isCommaSeparated = false
        }
        let tmpBalanceBeforeRequest;
        let tmpBalanceAfterRequest;
        
        if (isCommaSeparated) {
            const HoursOffc = json.HoursOff.replace(',', '.');
            const DaysOffc = json.DaysOff.replace(',', '.');
            //A Work Comment out
            // tmpBalanceBeforeRequest = formatMaxTwo(json.AvailableTimeOffBalance, true);
            // tmpBalanceAfterRequest = formatMaxTwo(
            //     isShowTimeOffInDays
            //         ? (parseFloat(tmpBalanceBeforeRequest.replace(',', '.')) - parseFloat(DaysOffc))
            //         : (parseFloat(tmpBalanceBeforeRequest.replace(',', '.')) - parseFloat(HoursOffc)),
            //     true
            // );
            tmpBalanceBeforeRequest = parseFlexibleDecimal(json.AvailableTimeOffBalance);
            tmpBalanceAfterRequest = (isShowTimeOffInDays ? (Number(tmpBalanceBeforeRequest) - Number(json.DaysOff)) : (Number(tmpBalanceBeforeRequest) - Number(HoursOffc))).toFixed(2).replace('.', ',');
            tmpBalanceBeforeRequest = tmpBalanceBeforeRequest.replace('.', ',');
        } else {
            //A Work Comment out
            // tmpBalanceBeforeRequest = formatMaxTwo(json.AvailableTimeOffBalance);
            // tmpBalanceAfterRequest = formatMaxTwo(
            //     isShowTimeOffInDays
            //         ? (Number(json.AvailableTimeOffBalance) - Number(json.DaysOff))
            //         : (Number(json.AvailableTimeOffBalance) - Number(json.HoursOff))
            // );
            const HoursOffc = json.HoursOff.replace(',', '.');
            const DaysOffc = json.DaysOff.replace(',', '.');
            tmpBalanceBeforeRequest = Number(json.AvailableTimeOffBalance).toFixed(2);
            //tmpBalanceBeforeRequest = Number(json.AvailableTimeOffBalance).toFixed(2);
            tmpBalanceAfterRequest = (isShowTimeOffInDays ? (Number(json.AvailableTimeOffBalance) - Number(DaysOffc)) : (Number(json.AvailableTimeOffBalance) - Number(HoursOffc))).toFixed(2);   
            //tmpBalanceAfterRequest = (isShowTimeOffInDays ? (Number(json.AvailableTimeOffBalance) - Number(json.DaysOff)) : (Number(json.AvailableTimeOffBalance) - Number(json.HoursOff))).toFixed(2);   
        }
        

        setTimeOffResponse({
            ...timeOffResponse,
             //dayOff: Number(json.DaysOff),
            // hoursOff: Number(json.HoursOff),
            dayOff: formatNumberCustomoriginalapiv2(culture, json.DaysOff, 2),
            hoursOff: formatNumberCustomoriginalapiv2(culture, json.HoursOff, 2),
           balanceBeforeRequest: tmpBalanceBeforeRequest,
            // request: isShowTimeOffInDays ? (isCommaSeparated ? json.DaysOff : Number(json.DaysOff)) : (isCommaSeparated ? json.HoursOff : Number(json.HoursOff)),
            // request: isShowTimeOffInDays ? (isCommaSeparated ? json.DaysOff : Number(json.DaysOff).toFixed(2)) : (isCommaSeparated ? json.HoursOff : Number(json.HoursOff).toFixed(2)),
            //A Work Comment Out
            //request: isShowTimeOffInDays  ? (isCommaSeparated ? formatMaxTwo(json.DaysOff).replace('.', ',') : formatMaxTwo(json.DaysOff)): (isCommaSeparated  ? formatMaxTwo(json.HoursOff).replace('.', ',') : formatMaxTwo(json.HoursOff)),
           // request: isShowTimeOffInDays ? (isCommaSeparated ? json.DaysOff : Number(json.DaysOff).toFixed(2)) : (isCommaSeparated ? json.HoursOff : Number(json.HoursOff).toFixed(2)),
            request: isShowTimeOffInDays  ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), json.DaysOff, 2) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), json.HoursOff, 2),
            
            balanceAfterRequest: tmpBalanceAfterRequest,
            endDate: dateFormatByAccountCulture(json.EndDate, cultureInfoName.toString()),
            startDate: (dateStatus == "StartDate") ? date : newStartDate,
        });
    }

    const onDateChange = (date: any, name: any) => {
        GetTimeOffCalculation(false, false, date, name == "StartDate" ? "StartDate" : "EndDate", "",true);
    }

    const onDropDownChange = (data: any, filterName: any) => {
        setTimeOffResponse({
            ...timeOffResponse,
            accountTimeOffTypeId: filterName.name == "timeofftypeList" ? timeOffResponse.timeOffTypeArray.filter((x: any) => x.value == data.value)[0].value : timeOffResponse.accountTimeOffTypeId,
            accountTimeOffTypeName: filterName.name == "timeofftypeList" ? timeOffResponse.timeOffTypeArray.filter((x: any) => x.value == data.value)[0].label : timeOffResponse.accountTimeOffTypeName,
            accountProjectId: filterName.name == "projectList" ? timeOffResponse.projectArray.filter((x: any) => x.value == data.value)[0].value : timeOffResponse.accountProjectId,
            tempTypeId: filterName.name == "timeofftypeList" ? timeOffResponse.timeOffTypeArray.filter((x: any) => x.value == data.value)[0].value : '',
        });
    }

    const convertNumberByCulture = (value: number | null, cultureInfoName?: string): string | null => {
        if (value === null || value === undefined) return null;

        const culture = (cultureInfoName || "").toLowerCase();
        const isCommaCulture = culture.startsWith("es") || culture.startsWith("fr");
        return isCommaCulture ? String(value).replace('.', ',') : String(value);
    };

    const onAddUpdateTimeOff = () => {
        const { accountTimeOffTypeId, accountTimeOffTypeName, startDate, endDate, hoursOff, dayOff, description, accountProjectId, isConsumptionAvailable, balanceBeforeRequest } = timeOffResponse
        const normalizedDayOff = parseLocalizedNumber(dayOff);
        const normalizedHoursOff = parseLocalizedNumber(hoursOff);
        const dayOffNum = normalizedDayOff != null ? Number(normalizedDayOff) : 0;
        const hoursOffNum = normalizedHoursOff != null ? Number(normalizedHoursOff) : 0;

        const activeValue = timeOffMode === 'Days' ? dayOffNum : hoursOffNum;
        if (activeValue === 0) {
            ShowToast('Error', `Days Off or Hours Off must be greater than 0`,'error', 'toast-top-right');
            return;
        }
        const initialBalance = parseFloat(balanceBeforeRequest);
        const balance = initialBalance - timeOffResponse.request;

        console.log("onAddUpdateTimeOff accountemployeetimeoffrequestid", accountemployeetimeoffrequestid)

        if (isConsumptionAvailable && balance <= 0) {
            ShowToast('Error', 'Consumption Not Available', "error", "toast-top-right");
        }
        else {
            dispatch(updateIsLoading(true));
            if (accountemployeetimeoffrequestid == '') {
            const normalizedHoursOff = parseLocalizedNumber(hoursOff);
            const normalizedDayOff = parseLocalizedNumber(dayOff);
                let object = {

                    StartDate: moment(startDate).format(dateInsertionFormat),
                    EndDate: moment(endDate).format(dateInsertionFormat),
                    // HoursOff: hoursOff,
                    // DayOff: dayOff,
                    HoursOff: normalizedHoursOff,
                    DayOff: normalizedDayOff,
                    AccountTimeOffTypeId: accountTimeOffTypeId,
                    Description: description,
                    // Hours: hoursOff,
                    Hours: normalizedHoursOff,
                    AccountProjectId: accountProjectId,
                    IsConsumptionAvailble: isConsumptionAvailable,
                    AccountTimeOffType: accountTimeOffTypeName,
                    HoursPerDay: hoursPerDay,
                    IsShowTimeOffInDays: isShowTimeOffInDays_preference
                }
                if (accountProjectId == 0) {
                    delete object.AccountProjectId;
                }
                dispatch(addAccountEmployeeTimeOffRequest(object)).then((result) => {
                    const requestId = result.payload.res[0].AccountEmployeeTimeOffRequestId;
                    tempAttachmentId != null && dispatch(addAttachment({ Id: requestId, Is: false, tempAttachmentId: tempAttachmentId, AccountAttachmentTypeId: 3 }))
                    dispatch(updateIsLoading(false));
                    if (closeButtonRef.current) {
                        closeButtonRef.current.click();
                    }
                    result.payload.res.constructor == Array ?
                        ShowToast('Success', "Time-off Request Added Successfully", "success", "toast-top-right") :
                        ShowToast('Error', result.payload.res.message, "error", "toast-top-right");
                }).catch((error) => {
                });
            }
            else {
            const normalizedHoursOff = parseLocalizedNumber(hoursOff);
            const normalizedDayOff = parseLocalizedNumber(dayOff);
                let object = {
                    StartDate: moment(startDate).format(dateInsertionFormat),
                    EndDate: moment(endDate).format(dateInsertionFormat),
                    // HoursOff: hoursOffFormatted,
                    // DayOff: dayOffFormatted,
                    HoursOff: normalizedHoursOff,
                    DayOff: normalizedDayOff,
                    AccountTimeOffTypeId: accountTimeOffTypeId,
                    Description: description,
                    AccountProjectId: accountProjectId,
                    AccountEmployeeTimeOffRequestId: accountemployeetimeoffrequestid,
                    HoursPerDay: hoursPerDay,
                    IsShowTimeOffInDays: isShowTimeOffInDays_preference
                }               
                dispatch(updateAccountEmployeeTimeOffRequest(object)).then((result) => {
                    if (closeButtonRef.current) {
                        closeButtonRef.current.click();
                    }
                    result.payload.res.Data.constructor == Array ?
                        ShowToast('Success', "Time-off Request Updated Successfully", "success", "toast-top-right") :
                        ShowToast('Error', "Time-off request cannot be updated.", "error", "toast-top-right");
                }).catch((error) => {
                });
            }
        }
        clearAttachmentUpload();
    }

    const updateTempAttachmentId = (value: any) => {
        setTempAttachmentId(value);
    }

    const clearAttachmentUpload = () => {
        if (attachmentUploadClearRef.current) {
            attachmentUploadClearRef.current();
        }
    }

    const getTimeOffInputValue = () => {
        return timeOffMode === 'Days' ? timeOffResponse.dayOff : timeOffResponse.hoursOff;
    };

    // const handleTimeOffModeChange = (mode: 'Days' | 'Hours') => {
    //     if (dayOffTimeoutRef.current) { clearTimeout(dayOffTimeoutRef.current); dayOffTimeoutRef.current = null; }
    //     if (hourOffTimeoutRef.current) { clearTimeout(hourOffTimeoutRef.current); hourOffTimeoutRef.current = null; }
    //     setTimeOffMode(mode);
    // };
    const handleTimeOffModeChange = (mode: 'Days' | 'Hours') => {
        if (dayOffTimeoutRef.current) {
            clearTimeout(dayOffTimeoutRef.current);
            dayOffTimeoutRef.current = null;
        }

        if (hourOffTimeoutRef.current) {
            clearTimeout(hourOffTimeoutRef.current);
            hourOffTimeoutRef.current = null;
        }

        setTimeOffResponse((prev: any) => {
            const currentDayOff = prev.dayOff;
            const currentHoursOff = prev.hoursOff;
            const dayOffNum = parseLocalizedNumber(currentDayOff);
            const hoursOffNum = parseLocalizedNumber(currentHoursOff);

            if (mode === 'Hours') {
                if (currentDayOff === '' ||currentDayOff === null ||currentDayOff === undefined ||Number(dayOffNum) === 0) {
                    return {
                        ...prev,
                        hoursOff: formatNumberCustomoriginal(cultureInfoName.toString(),'0',2),
                    };
                }
            }

            if (mode === 'Days') {
                if (currentHoursOff === '' ||currentHoursOff === null ||currentHoursOff === undefined || Number(hoursOffNum) === 0 ) {
                    return {
                        ...prev,
                        dayOff: formatNumberCustomoriginal(cultureInfoName.toString(),'0',2),
                    };
                }
            }

            return prev;
        });

        setTimeOffMode(mode);
    };

    return (
        <>
            <div className='card-body py-3' style={{ overflowY: 'auto' }}>
                {timeOffResponse.isCanvasLoader ? <CanvasLoader /> : <>
                    <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist' >
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Basic' })}
                                onClick={() => setTab('Basic')}
                                role='tab'
                                style={{ fontWeight: 500 }}
                            >
                                {/* {t("Time Off Request List")} */}
                                {getValueFromResource('Time Off Request List', dispatch, t)}
                            </a>

                        </li>
                        {enableUploadFeature && 
                        <li className='nav-item'>
                            <a
                                className={clsx(`nav-link cursor-pointer`, { active: tab === 'Attachment' })}
                                onClick={() => setTab('Attachment')}
                                role='tab'
                                style={{ fontWeight: 500 }}
                            >
                                {/* {t("Attachment")} */}
                                {getValueFromResource('Attachment', dispatch, t)}

                            </a>
                        </li> 
                        }
                    </ul>
                    <div className='tab-content pt-0'>
                        <div className={clsx('tab-pane', { active: tab === 'Basic' })}>
                            {isHideTimeOffHoursInformation != true &&
                                <>
                                    <div className='row' style={{ marginTop: 8 }}>
                                        <div className="col-md-12" >
                                            <label className='timeOff-hourStatus'>{isShowTimeOffInDays ? getValueFromResource("Days Request", dispatch, t) : getValueFromResource("Hours Request", dispatch, t)}</label>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-4">
                                            <div className='timeOffHours-Separator'>
                                                <span className="fw-bold d-block fs-4 tsNavBarInfoText timeOffHours-margin">{timeOffResponse.balanceBeforeRequest}</span>
                                                <a className="text-uppercase tsNavBarInfoLabel timeOffHours-margin">
                                                    {/* {t(`Balance before request`)} */}
                                                    {getValueFromResource('Balance before request', dispatch, t)}
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className='timeOffHours-Separator'>
                                                <span className="fw-bold d-block fs-4 tsNavBarInfoText timeOffHours-margin">{timeOffResponse.request}</span>
                                                <a className="text-uppercase tsNavBarInfoLabel timeOffHours-margin">
                                                    {/* {t(`This request`)} */}
                                                    {getValueFromResource('This request', dispatch, t)}
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className='timeOffHours-Separator'>
                                                <span className="fw-bold d-block fs-4 tsNavBarInfoText timeOffHours-margin">{timeOffResponse.balanceAfterRequest}</span>
                                                <a className="text-uppercase tsNavBarInfoLabel timeOffHours-margin">
                                                    {/* {t(`Balance after request`)} */}
                                                    {getValueFromResource('Balance after request', dispatch, t)}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            <div className='row mt-4'>
                                <div className="col-md-12 col-xs-12 col-sm-12 col-lg-12">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t(`Time Off Type`)} */}
                                        {getValueFromResource('Time Off Type', dispatch, t)}
                                    </label>
                                    <Select
                                        value={timeOffResponse.timeOffTypeArray.filter((x: any) => x.value == timeOffResponse.accountTimeOffTypeId)}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        name="timeofftypeList"
                                        onChange={(e, name) => onDropDownChange(e, name)}
                                        options={timeOffResponse.timeOffTypeArray}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                    />
                                </div>
                            </div>
                            <div className='row mt-4'>
                                <div className="col-md-6">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t(`Start Date`)} */}
                                        {getValueFromResource('Start Date', dispatch, t)}
                                    </label>
                                    <div className="wrapper">
                                        <DatePicker
                                            selected={timeOffResponse.startDate}
                                            onChange={(date) => onDateChange(date, "StartDate")}
                                            calendarStartDay={calendarStartDay}
                                            className="form-control dataPicker form-control-dark btn-icon-dark btn-text-dark"
                                            dateFormat={CurrentCultureDateFormat.toString()}
                                        >
                                        </DatePicker>
                                        <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t(`End Date`)} */}
                                        {getValueFromResource('End Date', dispatch, t)}
                                    </label>
                                    <div className="wrapper">
                                        <DatePicker
                                            selected={timeOffResponse.endDate}
                                            onChange={(date) => onDateChange(date, "EndDate")}
                                            calendarStartDay={calendarStartDay}
                                            className="form-control dataPicker form-control-dark btn-icon-dark btn-text-dark"
                                            dateFormat={CurrentCultureDateFormat.toString()}
                                        >
                                        </DatePicker>
                                        <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                    </div>
                                </div>
                            </div>
                            <div className='row mt-4'>
                                <div className="col-md-6">
                                    <label className="fs-7 fw-normal mb-2">
                                        {getValueFromResource(`${timeOffMode} Off`, dispatch, t)}
                                    </label>
                                    <div className="position-relative">
                                        <input
                                            type="text"
                                            className="form-control fs-7 fw-normal"
                                            style={{ paddingRight: '105px' }}
                                            value={getTimeOffInputValue()}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                const isDays = timeOffMode === 'Days';
                                                const timeoutRef = isDays ? dayOffTimeoutRef : hourOffTimeoutRef;

                                                if (timeoutRef.current) {
                                                    clearTimeout(timeoutRef.current);
                                                    timeoutRef.current = null;
                                                }

                                                if (val !== '' && !validateCultureNumber(val, cultureInfoName.toString(), 2)) {
                                                    return;
                                                }
                                                setTimeOffResponse((prev: any) => ({
                                                    ...prev,
                                                    ...(isDays
                                                        ? {
                                                            dayOff: val,
                                                            ...(val === '' ? { hoursOff: '0' } : {})
                                                        }
                                                        : {
                                                            hoursOff: val,
                                                            ...(val === '' ? { dayOff: '0' } : {})
                                                        })
                                                }));

                                                if (val === '') {
                                                    return;
                                                }

                                                // timeoutRef.current = setTimeout(() => {
                                                //     if (isDays) {
                                                //         GetTimeOffCalculation(false, true, '', '', val);
                                                //     } else {
                                                //         GetTimeOffCalculation(true, false, '', '', val);
                                                //     }
                                                // }, 1000);
                                            }}
                                            onBlur={(e) => {
                                                const val = e.target.value.trim();
                                                const isDays = timeOffMode === 'Days';
                                                const timeoutRef = isDays ? dayOffTimeoutRef : hourOffTimeoutRef;

                                                if (timeoutRef.current) {
                                                    clearTimeout(timeoutRef.current);
                                                    timeoutRef.current = null;
                                                }

                                                if (!val) {
                                                    const formatted = formatNumberCustomoriginal(cultureInfoName.toString(), '0', 2);
                                                    setTimeOffResponse((prev: any) => ({
                                                        ...prev,
                                                        ...(timeOffMode === 'Days' ? { dayOff: formatted } : { hoursOff: formatted })
                                                    }));
                                                    return;
                                                }

                                                const formatted = formatNumberCustomoriginal(cultureInfoName.toString(), val, 2);
                                                setTimeOffResponse((prev: any) => ({
                                                    ...prev,
                                                    ...(timeOffMode === 'Days' ? { dayOff: formatted } : { hoursOff: formatted })
                                                }));

                                                if (timeOffMode === 'Days') {
                                                    GetTimeOffCalculation(false, true, '', '', val);
                                                } else {
                                                    GetTimeOffCalculation(true, false, '', '', val);
                                                }
                                            }}
                                        />
                                        <div
                                            className="d-flex position-absolute"
                                            style={{
                                                top: '50%',
                                                right: '4px',
                                                transform: 'translateY(-50%)',
                                                border: '1px solid #cbd5e1',
                                                borderRadius: '4px',
                                                overflow: 'hidden',
                                                height: '28px'
                                            }} 
                                        >
                                            <button
                                                type="button"
                                                onClick={() => handleTimeOffModeChange('Days')}
                                                className="btn btn-sm"
                                                style={{
                                                    border: 'none',
                                                    borderRight: '1px solid #cbd5e1',
                                                    borderRadius: 0,
                                                    backgroundColor: timeOffMode === 'Days' ? 'var(--bs-primary-light)' : '#fff',
                                                    color: timeOffMode === 'Days' ? 'var(--bs-primary)' : '#7e8299',
                                                    fontWeight: timeOffMode === 'Days' ? 600 : 400,
                                                    padding: '0 10px',
                                                    fontSize: '11px',
                                                    lineHeight: '26px'
                                                }}
                                            >
                                                Days
                                            </button>

                                            <button
                                                type="button"
                                                onClick={() => handleTimeOffModeChange('Hours')}
                                                className="btn btn-sm"
                                                style={{
                                                    border: 'none',
                                                    borderRadius: 0,
                                                     backgroundColor: timeOffMode === 'Hours' ? 'var(--bs-primary-light)' : '#fff',
                                                    color: timeOffMode === 'Hours' ? 'var(--bs-primary)' : '#7e8299',
                                                    fontWeight: timeOffMode === 'Hours' ? 600 : 400,
                                                    padding: '0 10px',
                                                    fontSize: '11px',
                                                    lineHeight: '26px'
                                                }}
                                            >
                                                Hours
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className='row mt-4'> */}
                                {/* <div className="col-md-6"> */}
                                    {/* <label className="fs-7 fw-normal mb-2">
                                        {getValueFromResource('Days Off', dispatch, t)}
                                    </label> */}
                                    {/* <input
                                        type="number"
                                        className="form-control fs-7 fw-normal"
                                        value={timeOffResponse.dayOff}
                                        onBlur={(e) => {
                                            if (!isNaN(Number(e.target.value)) && e.target.value !== '') {
                                                GetTimeOffCalculation(false, true);
                                            }
                                        }}
                                        
                                        onChange={(e) => {
                                            if (!isNaN(Number(e.target.value)) && e.target.value !== '') {
                                                setTimeOffResponse({
                                                    ...timeOffResponse,
                                                    dayOff: e.target.value
                                                });
                                            }
                                        }}
                                    /> */}
                                    {/* <input
                                        type="text"
                                        className="form-control fs-7 fw-normal"
                                        id="dayOff"
                                        name="dayOff"
                                        value={timeOffResponse.dayOff}
                                        onBlur={(e) => { GetTimeOffCalculation(false, true); }}
                                        onChange={(e) => {
                                            setTimeOffResponse({
                                                ...timeOffResponse,
                                                dayOff: e.target.value
                                            });
                                        }}
                                    /> */}
                                    {/* <input
                                        type="text"
                                        className="form-control fs-7 fw-normal"
                                        id="dayOff"
                                        name="dayOff"
                                        value={timeOffResponse.dayOff}
                                        // onChange={(e) => {
                                        //     const val = e.target.value;
                                        //     if (!validateCultureNumber(val, cultureInfoName.toString(), 2)) {
                                        //         return;
                                        //     }
                                        //     setTimeOffResponse({
                                        //         ...timeOffResponse,
                                        //         dayOff: val
                                        //     });
                                        // }}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (!validateCultureNumber(val, cultureInfoName.toString(), 2)) return;
                                            setTimeOffResponse((prev: any) => ({
                                                ...prev,
                                                dayOff: val
                                            }));
                                            if (dayOffTimeoutRef.current) clearTimeout(dayOffTimeoutRef.current);

                                            // dayOffTimeoutRef.current = setTimeout(() => {
                                            //     GetTimeOffCalculation(false, true, '', '', val);
                                            // }, 1000);
                                        }}
                                        onBlur={(e) => {
                                            let val = e.target.value.trim();
                                            if (!val || val === '') {
                                                const formatted = formatNumberCustomoriginal(
                                                    cultureInfoName.toString(),
                                                    '0',
                                                    2
                                                );
                                                setTimeOffResponse({
                                                    ...timeOffResponse,
                                                    dayOff: formatted
                                                });
                                            } else {
                                                const formatted = formatNumberCustomoriginal(
                                                    cultureInfoName.toString(),
                                                    timeOffResponse.dayOff,
                                                    2
                                                );
                                                setTimeOffResponse({
                                                    ...timeOffResponse,
                                                    dayOff: formatted
                                                });
                                                //GetTimeOffCalculation(false, true);
                                            }
                                        }}
                                    /> */}
                                {/* </div> */}
                                {/* <div className="col-md-6"> */}
                                    {/* <label className="fs-7 fw-normal mb-2">
                                        {getValueFromResource('Hours Off', dispatch, t)}
                                    </label> */}
                                    {/* <input
                                        type="number"
                                        className="form-control fs-7 fw-normal"
                                        value={timeOffResponse.hoursOff}
                                        onBlur={(e) => {
                                            if (!isNaN(Number(e.target.value)) && e.target.value !== '') {
                                                GetTimeOffCalculation(true, false);
                                        }}
                                        onChange={(e) => {
                                                setTimeOffResponse({
                                                    ...timeOffResponse,
                                                    hoursOff: e.target.value
                                                });
                                            }
                                        }}
                                    /> */}
                                    {/* <input
                                        type="text"
                                        className="form-control fs-7 fw-normal"
                                        value={timeOffResponse.hoursOff}
                                        onBlur={(e) => { GetTimeOffCalculation(true, false);}}
                                        onChange={(e) => {
                                                setTimeOffResponse({
                                                    ...timeOffResponse,
                                                    hoursOff: e.target.value
                                                });
                                        }}
                                    /> */}
                                    {/* <input
                                        type="text"
                                        className="form-control fs-7 fw-normal"
                                        value={timeOffResponse.hoursOff}
                                                                                onBlur={(e) => {
                                                                                        GetTimeOffCalculation(true, false);
                                                                                }}
                                                                                onChange={(e) => {
                                                                                        setTimeOffResponse({
                                                                                            ...timeOffResponse,
                                                                                            hoursOff: e.target.value
                                                                                        });                                          
                                                                                }} 
                                        // onChange={(e) => {
                                        //     const val = e.target.value;
                                        //     if (!validateCultureNumber(val, cultureInfoName.toString(), 2)) {
                                        //         return;
                                        //     }
                                        //     setTimeOffResponse({
                                        //         ...timeOffResponse,
                                        //         hoursOff: val
                                        //     });
                                        // }}
                                        //  onChange={(e) => {
                                        //     const val = e.target.value;
                                        //     if (!validateCultureNumber(val, cultureInfoName.toString(), 2)) return;
                                        //     setTimeOffResponse((prev: any) => ({
                                        //         ...prev,
                                        //         hoursOff: val
                                        //     }));
                                        //     if (hourOffTimeoutRef.current) clearTimeout(hourOffTimeoutRef.current);

                                        //     hourOffTimeoutRef.current = setTimeout(() => {
                                        //         GetTimeOffCalculation(true, false, '', '', val);
                                        //     }, 1000);
                                        // }}
                                        onBlur={(e) => {
                                            let val = e.target.value.trim();
                                            // If empty or invalid, set to 0
                                            if (!val || val === '') {
                                                const formatted = formatNumberCustomoriginal(
                                                    cultureInfoName.toString(),
                                                    '0',
                                                    2
                                                );
                                                setTimeOffResponse({
                                                    ...timeOffResponse,
                                                    hoursOff: formatted
                                                });
                                            } else {
                                                const formatted = formatNumberCustomoriginal(
                                                    cultureInfoName.toString(),
                                                    timeOffResponse.hoursOff,
                                                    2
                                                );
                                                setTimeOffResponse({
                                                    ...timeOffResponse,
                                                    hoursOff: formatted
                                                });
                                                GetTimeOffCalculation(true, false);
                                            }
                                        }}
                                    /> */}
                                {/* </div> */}
                            {/* </div> */}
                            <div className='row mt-4'>
                                <div className="col-md-12">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t(`Description`)} */}
                                        {getValueFromResource('Description', dispatch, t)}
                                    </label>
                                    <textarea
                                        value={timeOffResponse.description}
                                        onChange={(e) => {
                                            setTimeOffResponse({
                                                ...timeOffResponse,
                                                description: e.target.value
                                            })
                                        }}
                                        className={"form-control"} rows={4}></textarea>
                                </div>
                            </div>
                            {isShowProjectForTimeOff && <div className='row mt-4'>
                                <div className="col-md-6">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t('Project Name')} */}
                                        {getValueFromResource('Project Name', dispatch, t)}
                                    </label>
                                    <Select
                                        value={timeOffResponse.projectArray.filter((x: any) => x.value == timeOffResponse.accountProjectId)}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        name="projectList"
                                        onChange={(e, name) => onDropDownChange(e, name)}
                                        options={timeOffResponse.projectArray}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                        menuPlacement={"top"}
                                    />
                                </div>
                            </div>}
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'Attachment' })}>
                            <AttachmentUpload
                                Id={accountemployeetimeoffrequestid}
                                onupdateTempAttachmentId={updateTempAttachmentId}
                                clearRef={attachmentUploadClearRef}
                                AccountAttachmentTypeId={3}
                            />
                            {tab === 'Attachment' && (accountemployeetimeoffrequestid && accountemployeetimeoffrequestid !== '00000000-0000-0000-0000-000000000000' && accountemployeetimeoffrequestid !== '') ? (
                                <GetAttachments Id={accountemployeetimeoffrequestid} AccountAttachmentTypeId={3} IsShowEmployeeInformation={false} isDisabled={true} />
                            ) : null}
                        </div>
                    </div>
                </>}
            </div>
            <div className='card-footer pt-4'>
                <div className='d-flex flex-end'>
                    <button
                        ref={closeButtonRef}
                        type="button"
                        className="btn btn-secondary btn-bs-btn-font-weight  me-2 btn-sm fs-7"
                        id="kt_OffCanvas"
                    >
                        {/* {t('Cancel')} */}
                        {getValueFromResource('Cancel', dispatch, t)}
                    </button>
                    <a className={"btn btn-primary btn-sm"} onClick={() => { onAddUpdateTimeOff() }}>
                        {/* {t('Save')} */}
                        {getValueFromResource('Submit', dispatch, t)}
                    </a>
                </div>
            </div>
        </>
    )
});

export default TimeOffRequestAddUpdate